/* @flow strict */

import * as React from 'react';
import Modal from './../../../components/Modal';
import Frame from '../frame';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleToggleModal: (boolean) => void
};

class IntegrationsCalendarPreviewModal extends React.Component<PropsType> {
  state = {
  }

  handleClose = (): any => {
    const { handleToggleModal } = this.props;

    handleToggleModal(false);
  };


  render(): React.Element {
    const { isOpen } = this.props;
    const {

    } = this.state;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        fullScreen
      >
        <div
          className="modal-dialog IntegrationsCalendarPreviewModal sale-preview-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <header className="sparxo-header sparxo-header-white">
                <div className="sparxo-navbar sparxo-navbar-white">
                  <div className="sparxo-navbar-left">
                    <span
                      className="sparxo-navbar-back close"
                      onClick={this.handleClose}
                    >
                      <i className="icon icon-angle-left" />
                      <span>Close</span>
                    </span>
                  </div>
                </div>
              </header>
            </div>
            <div className="modal-body">
              <div className="preview-view" style={{ height: '100%' }}>

                <Frame page='calendar' />

              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default IntegrationsCalendarPreviewModal;
